export default "query getTrialQuery($trialId: String!) {\n    getTrialById(trialId: $trialId) {\n        id\n    }\n}";